import React from "react";
import "./Content.css";
import GalleryItem from "./Gallery";

function Content() {
  return (
    <>
      <div className="container">
        <div className="grid-container">
          <div>
            <div className="flexbox-item">
              <GalleryItem
                fileName="carlos-jumping-on-the-unicycle.JPG"
                alt="Carlos Mario Lopez performing giraffe unicycle"
                style={{ width: "100%", height: "80%" }}
              ></GalleryItem>
            </div>
            {/* <div className="flexbox-item">
              <GalleryItem
                fileName="planetarium.jpg"
                alt="Circus performance at Planetarium in Buenos Aires"
                style={{ width: "100%", height: "80%" }}
              ></GalleryItem>
              Buenos Aires, Argentina
            </div> */}
            <div className="flexbox-item">
              <GalleryItem
                fileName="kermes.jpg"
                alt="Carlos Mario performing at a Kermes theater in Buenos Aires"
                style={{ width: "100%", height: "80%" }}
              ></GalleryItem>
              Buenos Aires, Argentina
            </div>
            <div className="flexbox-item">
              <GalleryItem
                fileName="monociclo.jpg"
                alt="Carlos Mario Lopez riding a unicycle"
                style={{ width: "100%", height: "100%" }}
              ></GalleryItem>
            </div>
            {/* <div className="flexbox-item">
              <GalleryItem
                fileName="crystal.jpg"
                alt="Carlos Mario performing with a crystal ball"
                style={{ width: "100%", height: "100%" }}
              ></GalleryItem>
            </div> */}
          </div>
          {/*
          // Right
          */}
          <div>
            <div className="flexbox-item">
              <GalleryItem
                fileName="Carlos-equilibrium-show.jpg"
                alt="Carlos Mario Lopez performing giraffe unicycle"
                style={{ width: "100%", height: "80%" }}
              ></GalleryItem>
            </div>
            <div className="flexbox-item">
              <GalleryItem
                fileName="carlos-glitter.PNG"
                alt="Carlos Mario Lopez performing giraffe unicycle"
                style={{ width: "100%", height: "80%" }}
              ></GalleryItem>
            </div>
            <div className="flexbox-item">
              <GalleryItem
                fileName="playa.jpg"
                alt="Carlos Mario hat juggling on the beach in Mar del Plata"
                style={{ width: "100%", height: "100%" }}
              ></GalleryItem>
              Mar del Plata, Argentina
            </div>
            {/* <div className="flexbox-item">
              <GalleryItem
                fileName="westerpark.jpg"
                alt="Club passing at Westerpark in Amsterdam"
                style={{ width: "100%", height: "100%" }}
              ></GalleryItem>
              <br></br>
              Amsterdam, Netherlands
            </div> */}
            {/* <div className="flexbox-item">
              <GalleryItem
                fileName="pataparriba.jpg"
                alt="Carlos Mario Lopez performing giraffe unicycle"
                style={{ width: "100%", height: "80%" }}
              ></GalleryItem>
            </div> */}
            {/* <div class="flexbox-item">
                        <GalleryItem
                            filePath = {ruigaard1}
                            style = {{width: '10%', height:'10%'}}
                            isVideo = {true} >
                        </GalleryItem>
                        </div> */}
            {/* <div className="flexbox-item">
              <GalleryItem
                fileName="hula.jpg"
                alt="Carlos Mario performing with hula hoops at Landjuweel Festival"
                style={{ width: "100%", height: "100%" }}
              ></GalleryItem>
              Landjuweel Festival, Netherlands
            </div> */}
            {/* <div className="flexbox-item">
              <GalleryItem
                fileName="w1.jpg"
                alt="Circus performance in Amsterdam"
                style={{ width: "100%", height: "100%" }}
              ></GalleryItem>
              Amsterdam, Netherlands
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Content;
